var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "week-calendar" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-2" },
      [
        _c(
          "b-button",
          {
            attrs: { size: "sm", variant: "outline-primary" },
            on: { click: _vm.prevWeek },
          },
          [_vm._v("Prev")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "h6 m-0" }, [_vm._v(_vm._s(_vm.rangeLabel))]),
        _vm._v(" "),
        _c(
          "b-button",
          {
            attrs: { size: "sm", variant: "outline-primary" },
            on: { click: _vm.nextWeek },
          },
          [_vm._v("Next")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid" },
      [
        _c(
          "div",
          { staticClass: "time-col" },
          _vm._l(_vm.times, function (t) {
            return _c("div", { key: t, staticClass: "time-slot" }, [
              _vm._v(_vm._s(t)),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm._l(_vm.days, function (day, idx) {
          return _c("div", { key: idx, staticClass: "day-col" }, [
            _c("div", { staticClass: "day-header" }, [
              _vm._v(_vm._s(day.label)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "day-body" },
              [
                _vm._l(_vm.times, function (t) {
                  return _c("div", {
                    key: day.date.toISOString() + t,
                    staticClass: "time-slot",
                  })
                }),
                _vm._v(" "),
                _vm._l(_vm.eventsByDay[day.key], function (ev, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      class: ["event", _vm.statusClass(ev.post)],
                      style: _vm.eventStyle(ev),
                      attrs: { title: _vm.eventTitle(ev) },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("post-click", ev.post)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "event-title" }, [
                        _vm._v(_vm._s(_vm.eventTitle(ev))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-time" }, [
                        _vm._v(
                          _vm._s(_vm.formatTime(ev.start)) +
                            " – " +
                            _vm._s(_vm.formatTime(ev.end))
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }